jQuery(window).on("load resize scroll",function(e){
	var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	if (scrollTop>1) {
		document.body.classList.add('scrolling-started');
	}
	else {
		document.body.classList.remove('scrolling-started');
	}
});
